import {UI} from "../../stem-core/src/ui/UIBase";

import {styleRule, StyleSheet} from "../../stem-core/src/ui/Style";
import {Device} from "../../stem-core/src/base/Device";
import {registerStyle} from "../../stem-core/src/ui/style/Theme";
import {Button} from "../../stem-core/src/ui/button/Button.jsx";
import {DEFAULT_TRANSITION} from "../../blink-sdk/Constants.js";


export class MerchantButtonStyle extends StyleSheet {
    @styleRule
    blinkButton = {
        outline: 0,
        cursor: "pointer",
        transition: DEFAULT_TRANSITION,
        "-webkit-user-select": "none",
        userSelect: "none",
        color: this.themeProps.MERCHANT_BUTTON_PRIMARY_TEXT_COLOR,
        background: this.themeProps.MERCHANT_BUTTON_PRIMARY_BACKGROUND,
        border: () => "1px solid " + this.themeProps.MERCHANT_BUTTON_PRIMARY_BORDER_COLOR,
        ":hover": {
            background: this.themeProps.MERCHANT_BUTTON_PRIMARY_BACKGROUND_HOVER,
            color: this.themeProps.MERCHANT_BUTTON_PRIMARY_TEXT_COLOR_HOVER,
            borderColor: this.themeProps.MERCHANT_BUTTON_PRIMARY_BORDER_COLOR_HOVER,
        },
        ":disabled": {
            color: this.themeProps.MERCHANT_BUTTON_PRIMARY_INACTIVE_TEXT_COLOR,
            cursor: "not-allowed",
            pointerEvents: () => (Device.isMobileDevice() ? "none" : ""),
        },
        ":disabled:hover": {
            background: this.themeProps.MERCHANT_BUTTON_PRIMARY_BACKGROUND,
            borderColor: this.themeProps.MERCHANT_BUTTON_PRIMARY_BORDER_COLOR,
        },
        boxShadow: "none",
        textShadow: "none",
        padding: "12px !important",
        textAlign: "center",
        display: "block",
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_REGULAR,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
        borderRadius: this.themeProps.MERCHANT_BUTTON_INPUT_TOAST_BORDER_RADIUS,
        ...this.themeProps.MERCHANT_BUTTON_PRIMARY_STYLE,
    };

    Size() {}
    Level() {}
}

// TODO @cleanup do a button merge
@registerStyle(MerchantButtonStyle)
export class MerchantButton extends Button {
    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.blinkButton);
    }
}
